// ─── Catalogue des fonctions de TOUTE la suite (app d'administration) ──
// Les autres apps ne connaissent que LEURS modules ; l'administration, elle,
// doit pouvoir rattacher à un forfait n'importe quelle fonction, quelle que
// soit l'application. On compose donc ici tous les catalogues déclarés par les
// modules — c'est le seul endroit de la suite qui les importe tous.
//
// Ajouter une app = ajouter une entrée ici (avec son catalogue, ou [] tant que
// le module n'existe pas).
// On importe le FICHIER de déclaration, pas l'index du module : ces fichiers
// n'ont aucune dépendance, ce qui évite de tirer les écrans (et leurs modules
// natifs : caméra, impression…) dans le bundle de l'administration.
import { FONCTIONS_CORE } from '@mop/core';
import { FONCTIONS_CALENDRIER } from '@mop/feature-calendar/src/fonctions';
import { FONCTIONS_INVENTAIRE } from '@mop/feature-inventory/src/fonctions';
import { FONCTIONS_REPAS } from '@mop/feature-meals/src/fonctions';
import { FONCTIONS_FINANCE } from '@mop/feature-finance/src/fonctions';

export const APPS_SUITE = [
  { id: 'core',        emoji: '🧱', label: 'Commun (toutes les apps)', defs: FONCTIONS_CORE },
  { id: 'my-calendar', emoji: '📅', label: 'My Calendar',              defs: FONCTIONS_CALENDRIER },
  { id: 'my-inventory',emoji: '📦', label: 'My Inventory',             defs: FONCTIONS_INVENTAIRE },
  { id: 'my-meals',    emoji: '🍽️', label: 'My Meals',                 defs: FONCTIONS_REPAS },
  { id: 'my-finance',  emoji: '💶', label: 'My Finance',               defs: FONCTIONS_FINANCE },
];

// Toutes les définitions, tous modules confondus (pour le moteur/les quotas).
export const CATALOGUE_SUITE = APPS_SUITE.flatMap(a => a.defs);

// Arborescence d'une app : racines (sans `parent`) + leurs sous-fonctions,
// regroupées par rubrique pour garder la lecture du catalogue d'origine.
export function arbreApp(app) {
  const defs = app.defs || [];
  const enfants = (cle) => defs.filter(d => d.parent === cle);
  const racines = defs.filter(d => !d.parent);
  const rubriques = new Map();
  for (const r of racines) {
    const nom = r.rubrique || '—';
    if (!rubriques.has(nom)) rubriques.set(nom, []);
    rubriques.get(nom).push({ def: r, sous: enfants(r.key) });
  }
  return [...rubriques.entries()];
}
